import createScene from './experience/createScene.js'
import createSizes from './experience/createSizes.js'
import createCamera from './experience/createCamera.js'
import createRenderer from './experience/createRenderer.js'
import createLoaders from './experience/createLoaders.js'
import createEnvironment from './experience/createEnvironment.js'
import createLights from './experience/createLights.js'
import createWall from './experience/createWall.js'
import tick from './experience/tick.js'

import createDebug from './experience/createDebug.js'
import setupWobbleGui from './experience/setupWobbleGui.js'
import createWobbleMaterial from './experience/createWobbleMaterial.js'
import createWobbleIco from './experience/createWobbleIco.js'
import createWobbleModel from './experience/createWobbleModel.js'

/**
 * Base
 */
const canvas = document.querySelector('canvas.webgl')
const scene = createScene()
const sizes = createSizes()

/**
 * Debug
 */
const { gui } = createDebug()

/**
 * Camera + Renderer
 */
const { camera, update: updateCamera, resize: resizeCamera } = createCamera({ sizes, canvas })
scene.add(camera)

const { renderer, render, resize: resizeRenderer } = createRenderer({ canvas, sizes })

/**
 * Loaders + Environment
 */
const { rgbeLoader, gltfLoader } = createLoaders()

createEnvironment({
  scene,
  rgbeLoader,
  hdrUrl: './urban_alley_01_1k.hdr'
})

/**
 * Lights + Wall
 */
createLights({ scene })
createWall({ scene })

/**
 * Wobble setups
 */

// Sun
const icoWobble = createWobbleMaterial({
  colorA: '#ff7b00',
  colorB: '#9d1010'
})

// AC char
const modelWobble = createWobbleMaterial({
  colorA: '#0000ff',
  colorB: '#ff0000',
})
modelWobble.uniforms.uStrength.value = 0.087

setupWobbleGui({ gui, wobble: icoWobble, label: 'Sun' })
setupWobbleGui({ gui, wobble: modelWobble, label: 'AC Character' })

/**
 * Objects
 */
const ico = createWobbleIco({ scene, wobble: icoWobble })
ico.position.set(-6, 6, -15)

createWobbleModel({
  scene,
  gltfLoader,
  wobble: modelWobble,
  url: './test2.glb'
})

/**
 * Resize handling
 */
sizes.onResize(() =>
{
  resizeCamera()
  resizeRenderer()
})

/**
 * Animate
 */
tick({
  update: (elapsedTime) =>
  {
    icoWobble.uniforms.uTime.value = elapsedTime
    modelWobble.uniforms.uTime.value = elapsedTime

    updateCamera()
    render(scene, camera)
  }
})
